export const CORE_SCREENS = [
  { to: '/', label: '1. Welcome' },
  { to: '/auth', label: '2. Auth' },
  { to: '/signup', label: '3. Signup' },
  { to: '/verify-id', label: '4. Verify ID' },
  { to: '/profile-setup', label: '5. Profile Setup' },
  { to: '/host-tokens', label: '6. Starting Balance' },
  { to: '/guest-rate', label: '7. Guest Rate' },
  { to: '/trust-tier', label: '8. Trust Tier' },
  { to: '/youre-in', label: "9. You're In" },
  { to: '/lounge', label: '10. Lounge' },
  { to: '/lounge/peek/ava', label: '11. Profile Peek' },
  { to: '/chats', label: '12. Chats' },
  { to: '/chats/ava', label: '13. Chat Thread' },
  { to: '/invite-confirm/ava', label: '14. Invite Confirm' },
  { to: '/call/ava', label: '15. Call' },
  { to: '/post-call/ava', label: '16. Post Call' },
  { to: '/match/ava', label: '17. Match' },
  { to: '/wallet', label: '18. Wallet' },
  { to: '/earnings', label: '19. Earnings' },
];
